import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Card, CircularProgress, Typography } from '@mui/material';
import { TeamHierarchyDto } from '@act/shared/data-transfer-objects';
import { useEffect, useState } from 'react';
import {
  getTeam,
  loadTeamHierarchy,
  selectHierarchy,
  selectHierarchyLoadingStatus,
  selectTeamLoadingStatus,
  selectViewable,
  userAppSelectors,
} from 'redux/slices/usersSlice';
import { useAppDispatch, useAppSelector } from 'redux/store-hooks';
import { LoadingStatus } from 'redux/types/shared-types';
import styled from 'styled-components';
import { useAppNavigation } from 'react-components/app/routing/routes';
import GuideFilters from './components/guide-filters';
import GuideTable, { GuideTableData } from './components/guide-table';
import { Button } from '@act/storybook';

const RootContainer = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
`;

const DataBackground = styled.div`
  background-color: #f5f5f5;
  padding: 16px 24px;
  overflow: hidden auto;
`;

const ScrollableDiv = styled.div`
  overflow: scroll;
`;

const TitleDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 14px;
`;

const FiltersContainer = styled.div`
  padding: 24px;
  padding-bottom: 16px;
`;

const LoadingContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const GuideList = () => {
  const dispatch = useAppDispatch();
  const currentGuides = userAppSelectors.useSelectCurrentGuidesMap();
  const userMapLoading: LoadingStatus = useAppSelector(selectTeamLoadingStatus);
  const hierarchy: TeamHierarchyDto[] = useAppSelector(selectHierarchy);
  const viewableGuides = useAppSelector(selectViewable);
  const teamLoadingStatus = useAppSelector(selectTeamLoadingStatus);

  const hierarchyMapLoading: LoadingStatus = useAppSelector(
    selectHierarchyLoadingStatus
  );
  const isLoading =
    userMapLoading !== 'success' || hierarchyMapLoading !== 'success';
  const [filteredGuideData, setFilteredGuideData] = useState<GuideTableData[]>(
    []
  );
  const navigate = useAppNavigation();

  const goToDocket = (row?: GuideTableData) => {
    navigate.toDocket(row?.guideId);
  };

  useEffect(() => {
    dispatch(loadTeamHierarchy());
  }, []);

  useEffect(() => {
    if (
      hierarchy?.length &&
      viewableGuides === null &&
      teamLoadingStatus !== 'loading'
    ) {
      void dispatch(getTeam({ params: { allViewable: true } }));
    }
  }, [hierarchy, viewableGuides]);

  if (isLoading) {
    return (
      <LoadingContainer>
        <CircularProgress />
      </LoadingContainer>
    );
  } else {
    return (
      <RootContainer>
        <Card variant="outlined">
          <TitleDiv>
            <Button onClick={() => goToDocket()} color="secondary">
              <ArrowBackIcon fontSize="medium" />
            </Button>
            <Typography variant="headlineSmall">Switch Guide View</Typography>
          </TitleDiv>
        </Card>
        <DataBackground>
          <Card variant="elevation">
            <ScrollableDiv>
              <FiltersContainer>
                <GuideFilters
                  hierarchy={hierarchy}
                  userMap={currentGuides}
                  setFilteredGuideData={setFilteredGuideData}
                />
              </FiltersContainer>
              <GuideTable
                guideData={filteredGuideData}
                onRowClick={goToDocket}
              />
            </ScrollableDiv>
          </Card>
        </DataBackground>
      </RootContainer>
    );
  }
};

export default GuideList;
